/** @format */

import React, { useEffect, useRef, useState } from 'react';
import { Button, Grid, Box, Paper, Typography } from '@mui/material';
import { PageContainer, StepperKeeperOld, ButtonLoading, ConfirmDialog, MessageCartableDg } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { useStyles } from './style';
import { useNavigate, useLocation } from 'react-router-dom';
import { enifyDateTime, getDynamicObjectAction, constBreadCrumbsTitle, getQuery } from 'utility';
import jMoment from 'moment-jalaali';
import { useQuery } from 'hooks';
import { BaseInfo, Constraints, Overview, GeneratedCodes, PrintComponent } from './components';
import CreateDiscountServices from './services/CreateDiscountServices';
import { VOUCHER_TYPES, PERCENTAGE_VOUCHER_INDEXES } from '../constants/VoucherConsts';
import useCustomHook from '../hooks';
import { animateScroll as scroll } from 'react-scroll';
import createToast from 'components/Toast/Toast';
import { useCurrencyUnit } from 'hooks';


const CreateDiscount = () => {
  /**
 * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
 */
  const actionsList =
    getDynamicObjectAction([
      'AddVoucher',
      'AddVoucherCustomersPage',
      'AddVouchersBtn'

    ]);
  // -- FORM DEFAULT VALUE --//
  const defaultValues = {
    // Base Info
    name: '', // [String]
    guildCode: '', // String
    description: '', // [String]
    amount: null, // [Float]
    discountPercentage: null, // [Float]
    hash: null, // [String]
    // Constraints
    count: '', // [Int]
    effectiveDates: jMoment(new Date()), // [String]
    expireDate: jMoment(new Date()).add(10, 'days'), // String
    productId: null, // [Int]
    minInvoiceItemCount: null, // [Int]
    minInvoiceAmount: null, // [Float]
    type: null, // "DISPOSABLE_ITEM" , "DISPOSABLE_INVOICE", "UNLIMITED"

    currencyCode: 'IRR',
    // Bellow fields are not usable now
    dealerBusinessId: [], // [Int]
    limitedConsumerId: null, // Int
  };

  // -- STATE --//

  const {
    voucherType,
    setVoucherType,
    consumeType,
    setConsumeType,
    selectedProducts,
    setSelectedProducts,
    selectedDealers,
    setSelectedDealers,
    targetUser,
    setTargetUser,
    activeStep,
    setActiveStep,
    loading,
    setLoading,
    isConfirmOpen,
    setIsConfirmOpen,
    generatedVouchers,
    setGeneratedVouchers,
    dataToExport,
    setDataToExport,
    titlesToExport,
    setTitlesToExport,
    totalCount,
    setTotalCount,
    isOpenMessageCartableDg,
    setIsOpenMessageCartableDg,
    requestId,
    setRequestId
  } = useCustomHook();
  // -- HOOKS --//
  const navigate = useNavigate();
  const currencyText = useCurrencyUnit(false);
  const componentRef = useRef();
  const methods = useForm({ defaultValues });
  const { handleSubmit, formState: { errors } } = methods;
  const classes = useStyles();
  const query = useQuery();
  const location = useLocation();
  const [urlQuery, setUrlQuery] = useState(null);

  useEffect(() => {
    let result = getQuery(location);
    setUrlQuery(result)
  }, [location]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setIsConfirmOpen(false);
    }
  }, [errors]);
  useEffect(() => {// زماینکه دیالوگ اطلاع رسانی نوع کارتابلی بسته شود ، ریکوعست آیدی خالی میشود
    !isOpenMessageCartableDg && setRequestId(null);
  }, [isOpenMessageCartableDg])
  /**
     * این اکشن داره چک میکنه اگه فیلد اجباری پر نشده باشه به کاربر خطارو توست نشون میده
     */
  useEffect(() => {
    if (methods.formState.errors && Object.keys(methods.formState.errors).length > 0 && methods.formState.submitCount > 0) {
      createToast('خطا', errorsToStr(methods.formState.errors), 'danger')
    }
  }, [methods.formState.submitCount]);

  const errorsToStr = (errs) => {
    if (!errs) return null;
    return (
      <div>
        {Object.keys(errs).map((v) => (
          <li>{errs[v]?.message}</li>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (query) {
      const tUser = {
        userId: query.get('id') ? query.get('id') : query.get('userId'),
        fullName: query.get('fullName'),
        username: query.get('username'),
        image: query.get('image'),
      };
      if (tUser?.image) {
        tUser.image = atob(tUser.image);
      }

      if (tUser?.userId) {
        setTargetUser(tUser);
      }
    }
  }, []);
  const handleKeyDown = (e) => {
    if (e.key == 'Enter' && e.target?.localName != 'textarea') {
      e.preventDefault();
    }
  };

  // -- API REQUESTS --//
  async function postVoucher(data) {
    setLoading(true);
    const params = {
      offset: 0,
      size: 10,
      typeCode: voucherType === 'amount' ? 'MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER' : 'MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER',
      guildCode: data?.guildCode?.code ?? null,
    };
    for (const key of Object.keys(params)) {
      if (params[key] === '') {
        delete params[key];
      }
    }
    setIsConfirmOpen(false);
    const voucherBody = {
      // Base Info
      name: data?.name ? [data?.name] : [], // [String]
      guildCode: data?.guildCode?.code ?? null, // String
      description: data?.description ? [data?.description] : [], // [String]
      amount: data?.amount ? [parseFloat(data?.amount)] : [], // [Float]

      // Constraints
      count: data?.count ? [parseInt(data?.count)] : [], // [Int]
      effectiveDates: data?.effectiveDates
        ? [enifyDateTime(data?.effectiveDates?.format('jYYYY/jMM/jDD'))]
        : [], // [String]
      expireDate: data?.expireDate
        ? enifyDateTime(data?.expireDate?.format('jYYYY/jMM/jDD'))
        : null, // String
      productId: selectedProducts.map((v) => v?.id), // [Int]
      minInvoiceItemCount: data?.minInvoiceItemCount ? [parseInt(data?.minInvoiceItemCount)] : [], // [Int]
      minInvoiceAmount: data?.minInvoiceAmount ? [parseFloat(data?.minInvoiceAmount)] : [], // [Float]

      currencyCode: 'IRR',
      perUserUsageLimitCount: data?.perUserUsageLimitCount
        ? [parseInt(data?.perUserUsageLimitCount)]
        : [],
      limitedConsumerId: targetUser?.userId ?? null,
      dealerBusinessId: selectedDealers.map((v) => v?.id), // [Int] //TODO: It's is for future sprting/releasesÎ
    };


    if (voucherType !== 'amount') {
      voucherBody.discountPercentage = data?.discountPercentage
        ? [parseFloat(data?.discountPercentage)]
        : []; // [Float]
      voucherBody.type = consumeType; // "DISPOSABLE_ITEM" , "DISPOSABLE_INVOICE", "UNLIMITED"
    }


    try {
      await CreateDiscountServices.checkCartable(params).then(async (response) => {
        if (response?.result?.length && response?.result[0]?.multiConfirmationSrv?.enable && !response?.result[0]?.multiConfirmationSrv?.left) {
          const guildCode = { 'guildCode': [data?.guildCode?.code || null] }
          let result = null;
          voucherBody['cartableId'] = response?.result[0]?.multiConfirmationSrv?.id
          if (voucherType === 'amount') {
            result = await CreateDiscountServices.postCartableAmount({ ...voucherBody, ...guildCode });
          } else {
            result = await CreateDiscountServices.postCartablePercentage({ ...voucherBody, ...guildCode });
          }
          if (result?.status == 200) {
            setRequestId(result?.result?.id);
            setIsOpenMessageCartableDg(true);
          }

        } else {
          let res = null;
          if (voucherType === 'amount') {
            res = await CreateDiscountServices.postAmountVourhcer(voucherBody);
          } else {
            res = await CreateDiscountServices.postPercentageVourhcer(voucherBody);
          }

          setGeneratedVouchers(res?.result);
          setTotalCount(voucherBody?.count);
          reformExportData(res?.result);
          setActiveStep(2);
          setLoading(false);
        }
        setLoading(false);
        scroll.scrollToTop();
      })

    } catch (e) {
      setLoading(false);
    }
  }
  const onSubmit = (data) => {
    if (data && data?.discountPercentage && String(data?.discountPercentage) == '0') { // 
      createToast('خطا', 'درصد تخفیف اشتباه است.', 'danger')
      return;
    }
    if (data && data?.amount && String(data?.amount) == '0') { // 
      createToast('خطا', `${voucherType === 'amount' ? 'مبلغ بن تخفیف' : 'سقف تخفیف'} اشتباه است.`, 'danger')
      return;
    }
    if (data && data?.count && String(data?.count) == '0') { // 
      createToast('خطا', 'تعداد بن تخفیف قابل صدور اشتباه است.', 'danger')
      return;
    }
    setIsConfirmOpen(true)
  }

  // -- OTHER FUNCTIONS --//
  const reformExportData = (vouchers) => {
    const keysToMap = [
      { t: 'شماره', k: 'id', f: null },
      { t: 'کد بن', k: 'hash', f: null },

      ...(PERCENTAGE_VOUCHER_INDEXES.includes(vouchers[0]?.type)
        ? [{ t: 'درصد تخفیف', k: 'discountPercentage', f: null }]
        : []),
      {
        t: PERCENTAGE_VOUCHER_INDEXES.includes(vouchers[0]?.type)
          ? `سقف تخفیف - ${currencyText}`
          : `مبلغ تخفیف - ${currencyText}`,
        k: 'creditAmount',
        f: null,
      },

      {
        t: 'تاریخ شروع',
        k: 'effectiveDate',
        f: (v) => enifyDateTime(jMoment(new Date(parseInt(v))).format('jYYYY/jM/jD HH:mm:ss')),
      },
      {
        t: 'تاریخ انقضا',
        k: 'expireDate',
        f: (v) => enifyDateTime(jMoment(v).format('jYYYY/jM/jD HH:mm:ss')),
      },
    ];

    const titles = keysToMap.map((v) => v?.t);

    const data = vouchers.map((v, k) =>
      keysToMap.map((item) => (v[item?.k] ? (item?.f ? item.f(v[item?.k]) : v[item?.k]) : '-')),
    );

    setTitlesToExport(titles);
    setDataToExport(data);
  }
  const hint =
    'شما در این بخش می‌توانید بن‌های تخفیف قابل استفاده در کسب‌وکار خود را تعریف نمایید. این‌ بن‌ها می‌توانند به دو صورت با تخفیف مبلغی یا درصدی تعریف شوند و امکان تعریف محدودیت روی زمان اعتبار، محصولات قابل خرید و حساب‌های تفصیلی قابل خرید وجود دارد.';

  return (
    <PageContainer subTitle={hint} title="ایجاد بن تخفیف" breadcrumbs={constBreadCrumbsTitle.VOUCHER_ADD_VOUCHER}>
      {targetUser?.userId && activeStep !== 2 ? (
        <Grid container>
          <Grid xs={6} item>
            <Paper className={classes.targetUser}>
              <Typography className={classes.targetTitle}>تخصیص بن تخفیف به کاربر</Typography>
              <Grid container className={classes.targetContainer}>
                <Grid item>
                  <img
                    alt={targetUser?.fullName ?? 'پروفایل کاربر'}
                    src={targetUser?.image ?? './images/profile.png'}
                    className={classes.profileImage}
                  />
                </Grid>
                <Grid item>
                  <Typography className={classes.targetFullName}>
                    {urlQuery?.isReport === 'true' ? (urlQuery?.firstName + ' ' + urlQuery?.lastName) : targetUser?.fullName ? targetUser?.fullName : '-'}

                  </Typography>
                  {urlQuery?.isReport !== 'true' && (
                    <Typography className={classes.targetUsername}>
                      {targetUser?.username ?? '-'}
                    </Typography>
                  )}
                  <Typography className={classes.targetId}>
                    شناسه کاربر :‌ {` ${targetUser?.userId}` ?? '-'}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      ) : null}
      {
        (actionsList['AddVoucher'] || actionsList['AddVoucherCustomersPage']) && <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off"
            onKeyDown={(e) => {
              handleKeyDown(e);
            }}>
            <StepperKeeperOld
              titles={[
                { label: 'اطلاعات پایه' },
                { label: 'محدودیت‌ها' },
                { label: 'دریافت بن‌های تخفیف' },
              ]}
              onStepChanged={activeStep !== 2 ? setActiveStep : () => { }}
              forceSelectedTabIndex={activeStep}
              stepsToHideNext={[1]}
              stepsToHidePrevious={[2]}
              unreachableIndexes={[2]}
              panels={[
                <BaseInfo voucherType={voucherType} setVoucherType={setVoucherType} />,
                <Constraints
                  consumeType={consumeType}
                  setConsumeType={setConsumeType}
                  voucherType={voucherType}
                  selectedProducts={selectedProducts}
                  setSelectedProducts={setSelectedProducts}
                  selectedDealers={selectedDealers}
                  setSelectedDealers={setSelectedDealers}
                />,
                <GeneratedCodes
                  codes={generatedVouchers}
                  totalCount={totalCount}
                  user={targetUser}
                />,
              ]}
              formAction={
                activeStep !== 2 ? (
                  <Grid container item xs={12} justifyContent="flex-end">
                    <div className={classes.containButton}>
                      {activeStep === 1 ? (

                        <ButtonLoading
                          variant="contained"
                          color="primary"
                          type="submit"
                          loading={loading}
                          name="ایجاد بن‌های تخفیف"
                        />

                      ) : null}

                    </div>
                  </Grid>
                ) : (
                  <Grid container item xs={12} justifyContent="flex-end">
                    <div className={classes.containButton}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          navigate('/Voucher');
                        }}
                      >
                        بازگشت به لیست بن‌ها
                      </Button>
                    </div>
                  </Grid>
                )
              }
            />

            {/* Confirm Voucher Modal */}
            <ConfirmDialog
              open={isConfirmOpen}
              onClose={() => setIsConfirmOpen(false)}
              onConfirm={handleSubmit(postVoucher)}
              title="تایید ایجاد بن تخفیف"
              confirmButtonText="ایجاد بن‌های تخفیف"
              cancelButtonText="انصراف"
            >
              <Overview
                targetUser={targetUser}
                products={selectedProducts}
                consumeType={consumeType}
                voucherType={voucherType}
                currencyText={currencyText}
              />
            </ConfirmDialog>

            <Box display="none" displayPrint="block">
              <PrintComponent
                ref={componentRef}
                titles={titlesToExport}
                data={dataToExport}
                title={`عنوان بن: ${generatedVouchers[0]?.name ?? '-'}  | نوع بن: ${VOUCHER_TYPES[generatedVouchers[0]?.type] ?? '-'
                  }
        | تاریخ ایجاد: ${generatedVouchers[0]?.creationDate
                    ? jMoment(generatedVouchers[0].creationDate).format('HH:mm:ss jYYYY/jM/jD')
                    : '-'
                  }`}
              />
            </Box>
          </form>
        </FormProvider>
      }

      <MessageCartableDg
        isOpenDg={isOpenMessageCartableDg}
        setIsOpenDg={setIsOpenMessageCartableDg}
        requestId={requestId}
        title='درخواست بن تخفیف'
      />
    </PageContainer>
  );
};

export default CreateDiscount;
